import React, { FC } from 'react';

import { EvInfoTooltip, EvTextInput, TEXT_INPUT_TYPES } from '@evinced-private/ui-common';

import { LOGIN_LABELS } from './LoginSettingsV2.labels';
import { FormLoginFieldsProps } from './LoginSettingsV2.types';

export const FormLoginFields: FC<FormLoginFieldsProps> = ({
	formLogin,
	onFieldChange,
	showCookiesConsentSelector,
	cookiesConsentSelector,
	onCookiesConsentChange
}) => (
	<div className="login-form">
		<div className="login-form-row">
			<span className="form-label">{LOGIN_LABELS.LOGIN_URL_LABEL}</span>
			<div className="form-field">
				<EvTextInput
					ariaLabel={LOGIN_LABELS.LOGIN_URL_LABEL}
					isRequired
					value={formLogin.loginURL}
					placeholder={LOGIN_LABELS.LOGIN_URL_PLACEHOLDER}
					onChange={(v) => onFieldChange('loginURL', v)}
				/>
			</div>
		</div>
		<div className="login-form-row">
			<span className="form-label">{LOGIN_LABELS.USER_NAME_LABEL}</span>
			<div className="form-field">
				<EvTextInput
					ariaLabel={LOGIN_LABELS.USER_NAME_LABEL}
					isRequired
					value={formLogin.userName}
					placeholder={LOGIN_LABELS.USER_NAME_PLACEHOLDER}
					onChange={(v) => onFieldChange('userName', v)}
				/>
			</div>
		</div>
		<div className="login-form-row">
			<span className="form-label">{LOGIN_LABELS.USER_NAME_SELECTOR_LABEL}</span>
			<div className="form-field">
				<EvTextInput
					ariaLabel={LOGIN_LABELS.USER_NAME_SELECTOR_LABEL}
					isRequired
					value={formLogin.usernameSelector}
					placeholder={LOGIN_LABELS.USER_NAME_SELECTOR_PLACEHOLDER}
					onChange={(v) => onFieldChange('usernameSelector', v)}
				/>
			</div>
			<div className="form-tooltip">
				<EvInfoTooltip title="" tooltipPlace="left">
					{LOGIN_LABELS.USER_NAME_SELECTOR_TOOLTIP}
				</EvInfoTooltip>
			</div>
		</div>
		<div className="login-form-row">
			<span className="form-label">{LOGIN_LABELS.PASSWORD_LABEL}</span>
			<div className="form-field">
				<EvTextInput
					ariaLabel={LOGIN_LABELS.PASSWORD_LABEL}
					isRequired
					value={formLogin.password}
					type={TEXT_INPUT_TYPES.PASSWORD}
					placeholder={LOGIN_LABELS.PASSWORD_PLACEHOLDER}
					onChange={(v) => onFieldChange('password', v)}
				/>
			</div>
		</div>
		<div className="login-form-row">
			<span className="form-label">{LOGIN_LABELS.PASSWORD_SELECTOR_LABEL}</span>
			<div className="form-field">
				<EvTextInput
					ariaLabel={LOGIN_LABELS.PASSWORD_SELECTOR_LABEL}
					isRequired
					value={formLogin.passwordSelector}
					placeholder={LOGIN_LABELS.PASSWORD_SELECTOR_PLACEHOLDER}
					onChange={(v) => onFieldChange('passwordSelector', v)}
				/>
			</div>
			<div className="form-tooltip">
				<EvInfoTooltip title="" tooltipPlace="left">
					{LOGIN_LABELS.PASSWORD_SELECTOR_TOOLTIP}
				</EvInfoTooltip>
			</div>
		</div>
		<div className="login-form-row">
			<span className="form-label">{LOGIN_LABELS.LOGIN_BUTTON_SELECTOR_LABEL}</span>
			<div className="form-field">
				<EvTextInput
					ariaLabel={LOGIN_LABELS.LOGIN_BUTTON_SELECTOR_LABEL}
					isRequired
					value={formLogin.loginButtonSelector}
					placeholder={LOGIN_LABELS.LOGIN_BUTTON_SELECTOR_PLACEHOLDER}
					onChange={(v) => onFieldChange('loginButtonSelector', v)}
				/>
			</div>
		</div>
		{showCookiesConsentSelector && (
			<div className="login-form-row">
				<span className="form-label">{LOGIN_LABELS.COOKIES_CONSENT_LABEL}</span>
				<div className="form-field">
					<EvTextInput
						ariaLabel={LOGIN_LABELS.COOKIES_CONSENT_LABEL}
						isRequired
						value={cookiesConsentSelector}
						placeholder={LOGIN_LABELS.COOKIES_CONSENT_PLACEHOLDER}
						onChange={onCookiesConsentChange}
					/>
				</div>
				<div className="form-tooltip">
					<EvInfoTooltip title={LOGIN_LABELS.COOKIES_CONSENT_TOOLTIP_TITLE} tooltipPlace="left">
						{LOGIN_LABELS.COOKIES_CONSENT_TOOLTIP}
					</EvInfoTooltip>
				</div>
			</div>
		)}
	</div>
);
